import React, { createContext, useContext, useState, useEffect } from 'react';
import AuthService from '../services/authService';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({ 
    loading: true, 
    user: null, 
    isAuthenticated: false 
  });
  
  const authService = new AuthService();

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const authResult = await authService.checkAuth();
      setAuth({
        loading: false,
        user: authResult.isAuthenticated ? authResult.user : null,
        isAuthenticated: authResult.isAuthenticated
      });
    } catch (error) {
      console.error('Auth status check failed:', error);
      setAuth({
        loading: false,
        user: null,
        isAuthenticated: false
      });
    }
  };

  const login = () => {
    authService.redirectToAuth();
  };

  const logout = async () => {
    try {
      await authService.logout();
      setAuth({ loading: false, user: null, isAuthenticated: false });
    } catch (error) {
      console.error('Logout failed:', error);
      // Force logout state even if API call fails
      setAuth({ loading: false, user: null, isAuthenticated: false });
    }
  };

  const value = {
    auth,
    login,
    logout,
    checkAuthStatus,
    isAuthenticated: auth.isAuthenticated,
    user: auth.user,
    loading: auth.loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 